import React, {useState} from "react";
import compact from 'lodash/compact';
import {Button, Form} from "react-bootstrap";
import {PriceSettings} from "./PriceSettings";
import {LABELS} from "./constants";
import {PRICE_SETTING_TYPES} from "../mall_specific";

export const PriceSettingSet = ({name, enabled, type, prices, index, onDeleteItem, onSettingsChanged}) => {
    const [isOpen, setIsOpen] = useState(false);
    prices ||= [];
    type ||= 'unspecified'
    name ||= `${LABELS[type]}設定${index + 1}`
    enabled = enabled === undefined ? true : enabled;

    const toggleState = () => {
        setIsOpen(!isOpen);
    };
    const toggleEnable = () => {
        onSettingsChanged(index, {
            enabled: !enabled,
        })
    };
    const onTypeChanged = (e) => {
        onSettingsChanged(index, {
            type: e.target.value,
        })
    }
    const onNameChanged = (e) => {
        onSettingsChanged(index, {
            name: e.target.value,
        })
    }
    const onDeleteItemSelf = () => {
        if (prices.length > 0 && enabled) {
            alert(`${name}を削除するには設定を無効にして下さい。`);
            return;
        }
        if (prices.length > 0 && !confirm(`${name}には${prices.length}個の価格設定が含まれます。削除しますか？`)) {
            return;
        }

        onDeleteItem(index);
    };
    const onPriceAddedSelf = () => {
        onSettingsChanged(index, {
            prices: [...prices, {}],
        })
    };
    const onPricesChanged = (prices) => {
        onSettingsChanged(index, {prices});
    };

    return <div>
        <div className="d-flex align-items-center price-setting-set">
            <span className="mr-2" onClick={toggleState}>
                {
                    isOpen && <i className="fa fa-times"/>
                }
                {
                    !isOpen && <i className="fa fa-plus"/>
                }
            </span>
            <span className="text-underline name" onClick={toggleState}>
                <input type="text" value={name}
                       name={`user_setting[price_settings][${index}][name]`}
                       onInput={onNameChanged}/>
                &nbsp;
                <span>({`${prices.length}`})</span>
            </span>
            <span className="flex-fill"/>
            <div>
                {
                    PRICE_SETTING_TYPES.map(st =>
                        <Form.Check id={`price-setting-${index}-${st}`}
                                    name={`user_setting[price_settings][${index}][type]`}
                                    label={LABELS[st]}
                                    key={`price-setting-${index}-${st}`}
                                    inline
                                    type="radio"
                                    value={st}
                                    onChange={onTypeChanged}
                                    checked={type === st}
                        />
                    )
                }
            </div>
            <Form.Switch
                label={enabled ? '有効' : '無効'}
                name={`user_setting[price_settings][${index}][enabled]`}
                checked={enabled}
                id={`price-setting-${index}-enabled`}
                onChange={toggleEnable}
            />
            <Button className="ml-4" variant="danger" onClick={_ => onDeleteItemSelf(index)}>削除</Button>
        </div>
        <div className={compact(['price-settings-container', isOpen ? 'open' : null]).join(' ')} >
            <PriceSettings prices={prices} index={index} onPriceAdded={onPriceAddedSelf} onChange={onPricesChanged} />
        </div>
    </div>;
}